import { render } from "./SupplierListTable.vue?vue&type=template&id=0c5a0b70&scoped=true"
import script from "./SupplierListTable.vue?vue&type=script&lang=js"
export * from "./SupplierListTable.vue?vue&type=script&lang=js"

import "./SupplierListTable.vue?vue&type=style&index=0&id=0c5a0b70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a0b70"]])

export default __exports__